"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfopagePreviewFrame = exports.isListPreviewFrame = void 0;
/** If preview frame content a List */
var isListPreviewFrame = function (content) { return content.items; };
exports.isListPreviewFrame = isListPreviewFrame;
/** Typeguard for is preview frame content an Infopage */
var isInfopagePreviewFrame = function (content) { return content.infopageContent; };
exports.isInfopagePreviewFrame = isInfopagePreviewFrame;
//# sourceMappingURL=previewFrame.js.map